import './App.css';
import { useEffect, useState, useRef } from "react";
import { RiDraggable } from "react-icons/ri";
import { IoStopCircleOutline } from "react-icons/io5";
import { IoMicOutline, IoMicOffSharp } from "react-icons/io5";
//import { PiScribbleLoopBold } from "react-icons/pi";
import secondToDuration from 'seconds-to-duration';

function App() {
  const videoDurationRef = useRef(secondToDuration(0));
  const isAudioMutedRef = useRef(false);
  //const laserPointerRef = useRef(false);

  const [videoDuration, setVideoDuration] = useState(videoDurationRef.current);
  const [isAudioMuted, setIsAudioMuted] = useState(isAudioMutedRef.current);
  //const [laserPointer, setLaserPointer] = useState(laserPointerRef.current);

  useEffect(() => {
    // Notify that React has loaded
    window.isReactReady = true;

    console.log(secondToDuration(1000));

    function handleVanillaEvent(event) {
      //console.log("Event received in React", event);

      const { message } = event.detail;

      if (message === 'VIDEO_UPDATE_DURATION') {
        videoDurationRef.current = secondToDuration(event.detail.duration.toString());
        setVideoDuration(videoDurationRef.current);
      } else if (message === 'AUDIO_UPDATE_MUTE') {
        isAudioMutedRef.current = true;
        setIsAudioMuted(true);
      } else if (message === 'AUDIO_UPDATE_UNMUTE') {
        isAudioMutedRef.current = false;
        setIsAudioMuted(false);
      }
    }

    window.addEventListener("fromEmbed", handleVanillaEvent);

    return () => {
      window.removeEventListener("fromEmbed", handleVanillaEvent);
    };
  }, []);

  const sendMessageToVanillaJS = (data) => {
    const event = new CustomEvent("fromVideo", { detail: data });
    window.dispatchEvent(event);
  };

  const iconStyle = {
    cursor: "pointer",
    display: "flex",
  }

  return (
    <div className="App">
      <div style={{
        cursor: "grab",
        opacity: 0.4,
        display: "flex",
      }}>
        <RiDraggable size={22} color='#3b3b3b' />
      </div>
      {/* <div style={{
        ...iconStyle,
        backgroundColor: laserPointer ? '#f6f6f6' : 'transparent',
        padding: laserPointer ? 10 : 0,
        borderRadius: laserPointer ? 5 : 0,
      }} onClick={() => {
        laserPointerRef.current = !laserPointer;
        setLaserPointer(laserPointerRef.current);
        sendMessageToVanillaJS({ message: "LASER_POINTER_TOGGLE", enabled: laserPointerRef.current });
      }}>
        <PiScribbleLoopBold size={22} color='#3b3b3b' />
      </div> */}
      <div style={iconStyle} onClick={() => {
        const newAudioMutedStatus = !isAudioMuted;
        isAudioMutedRef.current = newAudioMutedStatus;
        setIsAudioMuted(newAudioMutedStatus);
        sendMessageToVanillaJS({ 
          message: "AUDIO_RECORDING_TOGGLE",
          muted: newAudioMutedStatus
        });
      }}>
        {!isAudioMuted ? <IoMicOffSharp size={22} color='#585858' /> : <IoMicOutline size={22} color='#585858' />}
      </div>
      <div style={iconStyle} onClick={() => {
        sendMessageToVanillaJS({ message: "VIDEO_RECORDING_STOP" });
      }}>
        <IoStopCircleOutline size={22} color='#585858' />
      </div>
      <div style={{
        display: "flex",
        fontSize: 13,
        color: '#585858'
      }}>
        {videoDuration}
      </div>
    </div>
  );
}

export default App;
